import { ReportFeatures } from '@hcs/types';

export const COMPS_SUMMARY_SECTION_HEIGHT = 894;
export const COMPS_SUMMARY_FEATURES_SALE = [
  ReportFeatures.CompsSelect,
  ReportFeatures.CompsHcSuggested,
];
export const COMPS_SUMMARY_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsSelect,
  ReportFeatures.RentalCompsHcSuggested,
];

export const COMPS_LIST_TABS_ACTION_PORTAL_ID = 'compsListTabsActions';
